import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { DealerListComponent } from "./dealer-list/dealer-list.component";

@Component({
	selector: "app-dealer-admin-dashboard",
	templateUrl: "./dealer-admin-dashboard.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class DealerAdminDashboardComponent implements OnInit {
	@ViewChild("dealerListComponent") dealerListComponent: DealerListComponent;
	dealerIdSelected: string;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}
}
